/**
 * Estrutura de espera de resolução de processamento.
 */
class Waiter {
  accepted

  rejected

  constructor(accepted, rejected) {
    this.accepted = (...args) => {
      accepted(...args);
      return this;
    };
    this.rejected = (...args) => {
      rejected(...args);
      return this;
    };
  }

  // Gera um promessa que resolve se for aceito e rejeita se or recusado.
  // Se alwaysResolve = true, sempre será resolvida.
  toPromise({ alwaysResolve = false } = {}) {
    return new Promise((resolve, reject) => {
      this.accepted(resolve);
      this.rejected(alwaysResolve ? resolve : reject);
    });
  }

  // Gera um promessa que é resolvida com um bool indicando se foi aceito ou negado.
  toBool() {
    return new Promise((resolve) => {
      this.accepted(() => resolve(true));
      this.rejected(() => resolve(false));
    });
  }
}

/**
 * Gerenciador de espera.
 */
export default class WaitManager {
  // Aguardador para os ouvintes.
  waiter

  acceptedListeners

  rejectedListeners

  concluded

  accepted

  concludedArgs

  constructor() {
    this.concluded = false;
    this.acceptedListeners = [];
    this.rejectedListeners = [];
    this.waiter = new Waiter(
      (...args) => this.addAccepted(...args),
      (...args) => this.addRejected(...args),
    );
  }

  // Adiciona um ouvinte para quando for aceito.
  addAccepted(listener) {
    this.acceptedListeners.push(listener);
    if (this.concluded && this.accepted) {
      listener(...this.concludedArgs);
    }
  }

  // Adiciona um ouvinte para quando for recusado.
  addRejected(listener) {
    this.rejectedListeners.push(listener);
    if (this.concluded && !this.accepted) {
      listener(...this.concludedArgs);
    }
  }

  // Confirma a espera, disparando o evento de accepted no aguardador (waiter).
  accept(...args) {
    if (this.concluded) {
      throw new Error('Já finalizado.');
    }
    this.concluded = true;
    this.concludedArgs = args;
    this.accepted = true;
    this.acceptedListeners.forEach(l => l(...args));
  }

  // Rejeita a espera, disparando o evento de rejected no aguardador (waiter).
  reject(...args) {
    if (this.concluded) {
      throw new Error('Já finalizado.');
    }
    this.concluded = true;
    this.concludedArgs = args;
    this.accepted = false;
    this.rejectedListeners.forEach(l => l(...args));
  }
}
